<template>
  <div>
    <v-row>
      <v-col cols="6">
        <p class="overline mb-2 text-uppercase">BETYG BIFOGADE AV LÄRLING</p>
        <div
          class="attachment mb-2"
          v-for="c in gradeDocs"
          :key="c.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="c && c.fileName && c.internalFileName"
              @click="$emit('get-document',c)"
            >{{ c.fileName }}</a>
          </div>
          <v-btn
            :disabled="!approvedStateByCompany || certificateIsApproved || certificateIsCreated"
            text
            class="delete flex-grow-0 flex-shrink-0"
            @click="deleteDoc(c.id)"
          >
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </v-col>
      <v-col cols="6">
        <p class="overline mb-2">INTYG BIFOGADE AV LÄRLING</p>
        <div
          class="attachment mb-2"
          v-for="g in certificateDocs"
          :key="g.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="g && g.fileName && g.internalFileName"
              @click="$emit('get-document',g)"
            >{{ g.fileName }}</a>
          </div>
          <v-btn
            :disabled="!approvedStateByCompany || certificateIsApproved || certificateIsCreated"
            text
            class="delete flex-grow-0 flex-shrink-0"
            @click="deleteDoc(g.id)"
          >
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <p class="overline mb-2">FILER BIFOGADE AV ANVÄNDARE I REGISTRET</p>
        <div
          class="attachment mb-2"
          v-for="attachment in attachmentsDocs"
          :key="attachment.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="attachment.fileName"
              @click="$emit('get-document',attachment)"
            >{{ attachment.fileName }}</a>
          </div>
          <v-btn
            text
            :disabled="!approvedStateByCompany || certificateIsApproved || certificateIsCreated"
            class="delete flex-grow-0 flex-shrink-0"
            @click="deleteDoc(attachment.id)"
          >
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card-text
      class="pa-0"
      v-if="!(certificateIsCreated || certificateIsApproved)"
    >
      <v-file-input
        ref="inputattachment"
        class="mt-n5 d-none"
        accept=".pdf, .jpg, .tiff, .png"
        @change="uploadattachment"
      >
      </v-file-input>

      <v-btn
        outlined
        @click="$refs.inputattachment.$refs.input.click()"
      >
        <v-icon>$sl-upload-button</v-icon>Bifoga filer och dokument
      </v-btn>
    </v-card-text>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import get from 'lodash/get'

import API from '@/services/api'

export default {
  name: 'ApplicationDocumentsEdit',

  props: {
    gradeDocs: {
      type: Array,
      required: true
    },

    attachmentsDocs: {
      type: Array,
      required: true
    },

    certificateDocs: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'approvedStateByCompany']),

    certificateIsCreated() {
      const certificateId = get(this, 'selectedApplication.education.basicEducationCertificate.createdById', null)

      if (certificateId) {
        return true
      }
      return false
    },

    certificateIsApproved() {
      const certificateApproved = get(this, 'selectedApplication.education.basicEducationCertificate.approved', null)

      if (certificateApproved) {
        return true
      }
      return false
    }
  },

  methods: {
    get,

    async deleteDoc(id) {
      const res = await this.$dialog.confirm({
        text: 'Radering av dokumentet går inte att ångra.',
        title: 'Vill du radera dokumentet?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      API.deleteApplicationDocument(id)
        .then(response => {
          this.$emit('saved')
          // this.getApplication()
          this.$events.fire('showInfo', 'Dokumentet raderat.')
        })
        .catch(error => {
          this.$events.fire('showError', 'Tyvärr gick det inte att ta bort dokumentet.')
          console.log(error)
        })
    },

    uploadattachment(data) {
      if (!data) {
        return
      }
      const formData = new FormData()
      formData.append('file', data)
      formData.append('applicationId', this.selectedApplication.id)
      formData.append('applicationDocumentTypeId', 3)

      API.createApplicationDocument(formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          this.$events.fire('showInfo', 'Dokumentet bifogat.')
          this.$emit('saved')
          // TODO: we need to find a way to update selected application
          // this.getApplication()
        })
        .catch(error => {
          this.$events.fire('showError', 'Tyvärr gick det inte att ladda upp dokumentet')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>